// Drops a trailing ".00" so a whole-dollar minimum reads "$10" rather
// than "$10.00", while a fractional one still shows its cents.
const minFmt = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
});

/**
 * The one sentence that states the minimum-balance policy. Shared by
 * the notice under the Positions heading and the hero's Pending
 * tooltip, so the two surfaces cannot quote the same policy
 * differently. The figure is the account's own `minBalance` rather than
 * the policy constant, so the copy tracks whatever it is actually held
 * to.
 */
export function minBalanceNotice(minBalance: number): string {
    return `Minimum balance of ${minFmt.format(minBalance)} USDv required to earn.`;
}
